module.exports = __webpack_public_path__ + "images/emoji/no_pedestrians.622ddcb1bee2e7dcef13.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/no_pedestrians.png
// module id = w2w3
// module chunks = 14